import React from 'react';

import {
  Box,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tooltip,
  Spinner,
} from "@chakra-ui/react"

import { LogIn, LogOut } from 'react-feather';

import Credentials from './credentials';

export function AuthenticateModal({
  isOpen, 
  onOpen, 
  onClose, 
  isLoggedIn, 
  login, 
  signUp,
  logout,
  loading,
}) {  
  return (
    <>
      <Tooltip label={isLoggedIn ?'Log out' : 'Log in'}>
        <IconButton 
            icon={isLoggedIn ? <LogOut/> : <LogIn/>}
            size="sm"
            variant="solid"
            onClick={isLoggedIn ? logout : onOpen}
            colorScheme={isLoggedIn ? "red": "green"}
        />
      </Tooltip>
      
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Welcome</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs size="lg" variant="line" align="center" isFitted defaultIndex={1}>
              <TabList>
                  <Tab onClick={()=>{}}>Sign Up</Tab>
                  <Tab onClick={()=>{}}>Sign In</Tab>
              </TabList>
              <TabPanels>
                  <TabPanel>
                    <Credentials 
                      funcToRun={signUp} 
                      displayText="Register"
                    />
                  </TabPanel>                    
                  <TabPanel>
                    <Credentials 
                      funcToRun={login} 
                      displayText="Log in"
                    />
                  </TabPanel>
              </TabPanels>
            </Tabs>
          </ModalBody>
          <ModalFooter>
            {/* <Button colorScheme="blue" mr={3} onClick={onClose}>
              Log in
            </Button> */}
            <Box h={50}>
             {loading && <Spinner/>}
             </Box>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )


  

}

